import { FeeImmunityIcon } from '~/@mid_ui/icons/FeeImmunityIcon'
import {
  useFeeImmunity,
  FEE_IMMUNITY_MIN_INVESTMENT_AMOUNT,
} from '../useFeeImmunity'
import { useSettings } from '~/@mid_settings/settings'

interface OrderFeeImunityProps {
  currentValue: number
}

export function OrderFeeImunity({ currentValue }: OrderFeeImunityProps) {
  const { getLandingPageLink } = useSettings()

  const { showFeeImmunityPromo } = useFeeImmunity()
  if (!showFeeImmunityPromo) return null

  const stillRemaining = Math.max(
    0,
    FEE_IMMUNITY_MIN_INVESTMENT_AMOUNT - currentValue
  )

  return (
    <div className="flex items-center gap-6 bg-purple-2 p-6 mt-6">
      <FeeImmunityIcon className="size-8 shrink-0" />
      <div className="flex flex-col gap-3">
        <div className="text-lg flex flex-col gap-1">
          {stillRemaining === 0 ? (
            <>
              <div>
                <b>Táto investícia vám otvára dvere k poplatkovej imunite — </b>
                akonáhle vám príde e-mail potvrdzujúci poplatkovú imunitu, každá
                ďalšia investícia bude bez poplatkov.
              </div>
            </>
          ) : (
            <div>
              Investujte <b>ešte {stillRemaining} €</b> a môžete získať
              poplatkovú imunitu až do konca roka 2026.
            </div>
          )}
        </div>
        <a
          href={getLandingPageLink('poplatkova-imunita')}
          target="_blank"
          rel="noopener noreferrer"
          className="self-start text-accent underline hover:text-accent">
          Zistite viac
        </a>
      </div>
    </div>
  )
}
